import React, { useState } from 'react';

import { Box, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CloseIcon from '@mui/icons-material/Close';
import CancelButton from 'components/Buttons/CancelButton';
import SaveButton from 'components/Buttons/SaveButton';
import Transition from 'components/Transition';
import PropTypes from 'prop-types';
import SupplierDetailsForm from '../SupplierDetailsForm/SupplierDetailsForm';

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: theme.fonts.base,
    fontSize: 20,
    color: theme.palette.common.white
  },
  box: {
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  closeIcon: {
    color: theme.palette.common.white,
    fontSize: 26,
    cursor: 'pointer'
  },
  paper: {
    boxShadow: '0px 3px 14px #0000000F'
  },
  textField: {
    marginTop: theme.spacing(1),
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main
      }
    }
  },
  input: {
    fontFamily: theme.fonts.openSans,
    color: '#5C5C5C'
  },
  responsive: {
    minWidth: 300,
    [theme.breakpoints.up('md')]: {
      minWidth: 700
    }
  },
  confirm: {
    [theme.breakpoints.down('md')]: {
      display: 'flex'
    }
  }
}));

const SupplierDetailsEdit = ({ open, handleClose, details, loading, handleSave }) => {
  const classes = useStyles();

  const [formData, setFormData] = useState(details);

  const handleChange = (formData) => {
    setFormData(formData)
  };

  return (
    (<Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-supplier-details"
      keepMounted
      TransitionComponent={Transition}
      classes={{ paper: classes.paper }}
      maxWidth="xl"
    >
      <Box
        bgcolor="#2C324D"
        p={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
        className={classes.responsive}
      >
        <Typography className={classes.title}>Supplier Details</Typography>
        <CloseIcon className={classes.closeIcon} onClick={handleClose} />
      </Box>
      <DialogContent>
        <SupplierDetailsForm
          loading={loading}
          details={details}
          formChanged={handleChange}
        />
      </DialogContent>
      <DialogActions>
        <Box p={2} className={classes.confirm}>
          <CancelButton onClick={handleClose} />
          <SaveButton onClick={() => handleSave(formData)} loading={loading} />
        </Box>
      </DialogActions>
    </Dialog>)
  );
};

export default SupplierDetailsEdit;

SupplierDetailsEdit.defaultProps = {
  loading: false
};

SupplierDetailsEdit.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  details: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool,
  handleSave: PropTypes.func.isRequired
};
